var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-container"},[_c('input',{attrs:{"type":"radio","name":'radio-' + _vm.$parent._uid,"id":'option-' + _vm.optionValue},domProps:{"value":_vm.optionValue,"checked":_vm.checked},on:{"click":_vm.onClick}}),_c('label',{attrs:{"for":'option-' + _vm.optionValue}},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }